package com.bikompanion.domain

/** Where the map opens before the rider has moved it or shared a location. */
data class StartPosition(
    val latitude: Double,
    val longitude: Double,
)
